import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { Vehicle, CreateVehicleRequest } from '../types';

export const vehicleService = {
  getAll: async (): Promise<Vehicle[]> => {
    const response = await apiClient.get<Vehicle[]>(API_ENDPOINTS.VEHICLES.BASE);
    return response.data;
  },

  getActive: async (): Promise<Vehicle[]> => {
    const response = await apiClient.get<Vehicle[]>(API_ENDPOINTS.VEHICLES.ACTIVE);
    return response.data;
  },

  getById: async (id: number): Promise<Vehicle> => {
    const response = await apiClient.get<Vehicle>(API_ENDPOINTS.VEHICLES.BY_ID(id));
    return response.data;
  },

  create: async (data: CreateVehicleRequest): Promise<Vehicle> => {
    const response = await apiClient.post<Vehicle>(API_ENDPOINTS.VEHICLES.BASE, data);
    return response.data;
  },

  update: async (id: number, data: Partial<CreateVehicleRequest>): Promise<Vehicle> => {
    const response = await apiClient.put<Vehicle>(API_ENDPOINTS.VEHICLES.BY_ID(id), data);
    return response.data;
  },

  deactivate: async (id: number): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.VEHICLES.BY_ID(id));
  },
};
